import { render, staticRenderFns } from "./RegisterPackFlow.vue?vue&type=template&id=220af571&scoped=true&"
import script from "./RegisterPackFlow.vue?vue&type=script&lang=js&"
export * from "./RegisterPackFlow.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPackFlow.vue?vue&type=style&index=0&id=220af571&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220af571",
  null
  
)

export default component.exports